import { parseTime } from '@/utils/util'

export const searchForm = {
  state: undefined,
  user: '',
  password: ''
}

export const rules = {
  line_id: [ { required: true, message: '请选择业务线', trigger: 'change' } ],
  pc_detail_url: [ { required: true, message: '请输入PC文章详情地址', trigger: 'change' } ],
  app_detail_url: [ { required: true, message: '请输入APP文章详情地址', trigger: 'change' } ]
}

export const form = {
  line_id: undefined,
  typeids: [],
  pc_detail_url: '',
  app_detail_url: ''
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '业务线',
    dataIndex: 'org',
    width: 320,
    align: 'left',
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: 'PC文章详情页地址',
    dataIndex: 'pc_detail_url',
    width: 420,
    align: 'left'
  },
  {
    title: 'APP文章详情页地址',
    dataIndex: 'app_detail_url',
    width: 420,
    align: 'left'
  },
  {
    title: '编辑日期',
    dataIndex: 'updated_at',
    align: 'left',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    align: 'center',
    width: 160,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]
